import { Length, IsDecimal } from "class-validator";
import { v1 as uuidv1 } from 'uuid'
import ApplicationValue from "./application-value";

class Crop {

    constructor() {
      this.id = uuidv1();
    }

    id: string;

    @Length(1, 50)
    cropName: string = '';

    @Length(1, 50)
    cropType: string = '';

    @Length(1, 50)
    voivodeship: string = '';

    @Length(1, 50)
    district: string = '';

    @Length(1, 50)
    commune: string = '';

    @Length(1, 50)
    precinct: string = '';

    @Length(1, 50)
    parcelNumber: string = '';

    @Length(1, 20)
    occurrence: string = '';

    @Length(1, 50)
    soilClass: string = '';

    @Length(1, 50)
    soilCategory: string = '';
  
    @IsDecimal()
    area: number = 0;

    @IsDecimal()
    estimatedEfficiency: number = 0;

    @IsDecimal()
    estimatedPrice: number = 0;

    @IsDecimal()
    casting: number = 0;

    @IsDecimal()
    leafAmount: number = 0;

    insuranceCoverage: ApplicationValue[] = [];
  }

  export default Crop;